import { render, staticRenderFns } from "./Dog-Copropietario.vue?vue&type=template&id=43b90dd7&scoped=true&"
import script from "./Dog-Copropietario.vue?vue&type=script&lang=js&"
export * from "./Dog-Copropietario.vue?vue&type=script&lang=js&"
import style0 from "./Dog-Copropietario.vue?vue&type=style&index=0&id=43b90dd7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b90dd7",
  null
  
)

export default component.exports